import React, { useState, useEffect, useRef, useLayoutEffect } from 'react';
import logo from './logo.svg';
import './App.css';
import Helmet from "react-helmet";
import Button from '@material-ui/core/Button';
import NavBar from './components/_shared/NavBar';
import DenseAppBar from './components/_shared/DenseAppBar';
import Container from '@material-ui/core/Container';
import { Route, Switch, BrowserRouter as Router } from 'react-router-dom';
import SwitchRoutes from './components/SwitchRoutes';
import { createMuiTheme } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/styles';



const NavTabsWidth = 160;

function App() {


  const [size, setSize] = useState({ width: window.innerWidth, height: window.innerHeight });
  const [isMobile, setIsMobile] = useState(false);
 // const [navHeight, setNavHeight] = useState(0);

 useEffect(() => {
  try{
    setIsMobile(size.height > size.width);
   }catch(err){
  
   }
}, []);
 // let navRef = useRef(null);
 /*try{
  setIsMobile(size.height > size.width);
 }catch(err){

 }*/
  //isMobile = (isMobile === true ||isMobile === false)? isMobile: true; 
  
  const mainStyle = {
    marginLeft: isMobile ? 0 : NavTabsWidth,
    width: isMobile ? '100%' : window.innerWidth - NavTabsWidth,
  }/*
  const navStyle = {
    position: 'fixed',
    left: 0,
    bottom: isMobile ? 0 : '',
    height: isMobile ? "" : "100%",
    width: isMobile ? '100%' : NavTabsWidth,
    zIndex: 1, /* Stay on top 
  }*/

  const theme = createMuiTheme({
    palette: {
      primary: { main: '#0066ff' }, // Purple and green play nicely together.
      secondary: { main: '#ffcc00' }, // This is just green.A700 as hex.
    },
  });
/*
  useEffect(() => {
    handleWindowSizeChange();
    window.addEventListener('resize', handleWindowSizeChange);
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    }
  }, []);*/
/*
  useLayoutEffect(() => {
    setNavHeight(navRef? navRef.getBoundingClientRect().height : 0)
  }, [navRef]);
*/
  /*const handleWindowSizeChange = () => {
    setSize({ width: window.innerWidth, height: window.innerHeight });
  };
*/



    return (
      <div className="App">
        <Helmet title="SyncStats Monitoring" />
          
      <Router>
        <DenseAppBar/>
          <Container style={mainStyle} >
            
          <SwitchRoutes
            isMobile={isMobile}
          />{/**/}
        </Container>
        </Router>
      </div>
    );
  }


export default App;



// WEBPACK FOOTER //
// src/App.js